import { render, staticRenderFns } from "./RefundView.vue?vue&type=template&id=bedb9efc&scoped=true"
import script from "./RefundView.vue?vue&type=script&lang=js"
export * from "./RefundView.vue?vue&type=script&lang=js"
import style0 from "./RefundView.vue?vue&type=style&index=0&id=bedb9efc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bedb9efc",
  null
  
)

export default component.exports